module.exports = __webpack_public_path__ + "static/media/video3-goldcoast.9755b236.mp4";